import {
  PaymentPolicyType,
  ReservationLocation,
} from '@wix/ambassador-table-reservations-v1-reservation-location/types'
import {useCurrencyFormatter} from '@wix/yoshi-flow-editor'

export const usePaymentDetails = (
  reservationLocation?: ReservationLocation,
  partySize?: number | null,
) => {
  const formatCurrency = useCurrencyFormatter()

  const currency = reservationLocation?.currency || ''

  const {isPerGuestPayment, options} = getPaymentOptions(reservationLocation)

  const isPaymentRuleActive = !!(
    options?.minPartySize &&
    partySize &&
    partySize >= options?.minPartySize
  )
  const pricePerUnit = Number(options?.price) || 0
  const pricePerUnitWithCurrency = currency
    ? formatCurrency({value: pricePerUnit, currency})
    : String(pricePerUnit)

  const totalPrice = isPerGuestPayment ? pricePerUnit * (partySize || 0) : pricePerUnit
  const totalPriceWithCurrency = currency
    ? formatCurrency({value: totalPrice, currency})
    : totalPrice

  return {
    isPaymentRuleActive,
    isPerGuestPayment,
    pricePerUnit,
    pricePerUnitWithCurrency,
    totalPrice,
    totalPriceWithCurrency,
  }
}

function getPaymentOptions(reservationLocation?: ReservationLocation) {
  const paymentPolicy = reservationLocation?.configuration?.paymentPolicy

  const isPerGuestPayment = paymentPolicy?.paymentPolicyType === PaymentPolicyType.PER_GUEST
  const options = isPerGuestPayment
    ? paymentPolicy?.perGuestOptions
    : paymentPolicy?.perReservationOptions

  return {
    isPerGuestPayment,
    options,
  }
}
